import type { UserAirlineGroupEntry } from "../../types";

export const isGrouped = (entry: UserAirlineGroupEntry): boolean => !!entry.group;

export const codesOf = (entry: UserAirlineGroupEntry): string[] => entry.airlines.map((airline) => airline.code);

const entryIndexForCode = (groups: UserAirlineGroupEntry[], code: string): number =>
  groups.findIndex((entry) => codesOf(entry).includes(code));

export const selectionOwnerIndex = (groups: UserAirlineGroupEntry[], selected: string[]): number => {
  if (selected.length === 0) return -1;
  return groups.findIndex((entry) => {
    const codes = codesOf(entry);
    return selected.every((code) => codes.includes(code));
  });
};

export const isGroupFullySelected = (entry: UserAirlineGroupEntry, selected: string[]): boolean => {
  const codes = codesOf(entry);
  return codes.length > 0 && selected.length === codes.length && codes.every((code) => selected.includes(code));
};

export const toggleAirline = (groups: UserAirlineGroupEntry[], selected: string[], code: string): string[] => {
  const index = entryIndexForCode(groups, code);
  if (index === -1) return selected;

  const entry = groups[index];

  if (!isGrouped(entry)) {
    return selected.length === 1 && selected[0] === code ? [] : [code];
  }

  const isSameOwner = selectionOwnerIndex(groups, selected) === index;
  if (!isSameOwner) return [code];

  const next = new Set(selected);
  if (next.has(code)) next.delete(code);
  else next.add(code);
  return codesOf(entry).filter((groupCode) => next.has(groupCode));
};

export const toggleGroup = (groups: UserAirlineGroupEntry[], selected: string[], groupIndex: number): string[] => {
  const entry = groups[groupIndex];
  if (!entry || !isGrouped(entry)) return selected;
  return isGroupFullySelected(entry, selected) ? [] : codesOf(entry);
};
